import { PrepaymentStatus } from "../../../core/models/entities/PrepaymentStatus";
import { PrepaymentStatusDto } from "../responses/PrepaymentStatusDto";

export function mapToPrepaymentStatus(
  dto: PrepaymentStatusDto
): PrepaymentStatus {
  return {
    prepaymentRequired: dto.prepaymentRequired,
    billedVendorOrgId: dto.billedVendorOrgId,
    source: dto.source,
  };
}
